import { useRouteLoaderData as useRouteLoaderDataById } from 'react-router';
import type { Register } from 'react-router';

import type { RouteId } from '@jane/bloom/utils/routes/routeIds';

/** The loader function registered for a route id, or `never` if it has none. */
type LoaderFor<Id extends RouteId> = Register extends {
  routeModules: infer Modules;
}
  ? Id extends keyof Modules
    ? Modules[Id] extends { loader: infer Loader }
      ? Loader
      : never
    : never
  : never;

/**
 * Type-safe wrapper around React Router's `useRouteLoaderData`: `id` is
 * constrained to this app's real route ids, and the return type is inferred
 * from that route's loader — no generic argument needed at the call site.
 *
 * The loader type is handed to the underlying hook as its generic so that
 * React Router applies its own `SerializeFrom` serialization, matching a plain
 * `useLoaderData<typeof loader>()`.
 */
export function useTypedRouteLoaderData<Id extends RouteId>(id: Id) {
  return useRouteLoaderDataById<LoaderFor<Id>>(id);
}
